import React, { PropsWithChildren, useCallback, useMemo, useRef, useState } from 'react';
import {
  APIUsageContextType,
  APIUsageContext,
} from 'new/components/flows/types/genai_rag/context/APIUsage/APIUsageContext';

export function APIUsageContextProvider(props: PropsWithChildren<any>) {
  const [llm, setLLM] = useState(null);

  const providerValue = useMemo<APIUsageContextType>(() => {
    return {
      llm,
      setLLM,
    };
  }, [llm]);

  return (
    <APIUsageContext.Provider value={providerValue}>{props.children}</APIUsageContext.Provider>
  );
}
